/**
 * enum of Cart types
 * @readonly
 * @enum
 */
export var CartType;
(function (CartType) {
    CartType[CartType["DEFAULT"] = 0] = "DEFAULT";
    CartType[CartType["LANDING_PAGE"] = 1] = "LANDING_PAGE";
    CartType[CartType["QS_PARAMS"] = 2] = "QS_PARAMS";
    CartType[CartType["INTEGRATED_RETAILER"] = 3] = "INTEGRATED_RETAILER";
})(CartType || (CartType = {}));
